module.exports = __webpack_public_path__ + "static/zicatela-video-4ae8b382a6f67b809ae827146bf2fd8d.mp4";